import React, { useEffect, useReducer } from 'react';
import { REQUEST_DATA, initialState } from '../constants';
import Reducer, {ERROR, LOADING_DATA, SET_DATA} from '../reducer';
import api, {
  getApaAssets,
  getApaMetadata,
  getStartHeaderInfo,
  postAuthHBOSSO,
  postLoginHbo,
  updateDefaultsHBO
} from "../services";
import invariant from "invariant";
import _ from "lodash";
import getConfigEnv from "utils/getConfigEnv";
import {getBrowser} from "utils/Platform";
import {getAssetsModel, getLoginOptionsTabs, getMetadataModel, getTranslationsState} from "../selectors";
import FormPhone from "../components/Form/phone";
import LoginEmail from "../Login";
import * as constants from "../constants";
import {getFormErrors} from "../utils";
import {converter} from "helpers/converter";
import classNames from "classnames";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import qs from 'query-string';

const checkApiCallInvariant = ({ status, errors }, invariantText, args) =>
    invariant(_.parseInt(status) !== 1 && _.isEmpty(errors), invariantText, args);

const useHboLogin = () => {
  const params = qs.parse(window.location.search);
  console.log(params);
  const getForms = () => {
    try {
      const optionsLoginByRegion = getLoginOptionsTabs(state);
      const translations = getTranslationsState(state);
      const metadata = getMetadataModel(state);
      const assets = getAssetsModel(state);

      const renderTab = props => (
          <as>
            <img {...props} alt="" />
          </as>
      );

      const getFormById = id => {
        if (/sso/gi.test(id)) return FormPhone;
        if (/login_email/gi.test(id)) return LoginEmail;
        if (/claro_hogar/gi.test(id)) return LoginEmail;
        return null;
      };

      const getPropsById = id => {
        if (/sso/gi.test(id))
          return {
            onSendPhoneNumber: handleSubmitPhoneNumber,
            onSubmit: handleSubmitSSO,
            onChange: handleFormChange,
            login: true,
            showPinInput: state.pinCodeSent,
            msisdn: state.formsController.msisdn,
            otp: state.formsController.otp,
            translations,
          };
        if (/login_email/gi.test(id))
          return {
            onSubmit: handleLoginByEmail,
            login: true,
            translations,
            metadata,
            error: state.failModal,
            resetStep: state.resetStep,
            isLoading: state.loading,
            region: state.region,
            onClearError: handleClearErrors,
            onChange: handleFormChange,
          };
        if (/claro_hogar/gi.test(id))
          return {
            onSubmit: handleLoginByEmail,
            login: true,
            translations,
            metadata,
            error: state.failModal,
            resetStep: state.resetStep,
            isLoading: state.loading,
            onChange: handleFormChange,
            onClearError: handleClearErrors,
            region: state.region,
            hogar: true,
          };
        return null;
      };

      const forms = _.map(optionsLoginByRegion, ({ id }) => {
        const Form = getFormById(id);
        const props = getPropsById(id);
        if (_.isNil(Form) || /facebook/gi.test(id)) return {};
        const icon =
            _.get(assets, `${state.region}_${id}_asset`) ||
            _.get(assets, `default_${id}_asset`);
        return {
          menuItem: renderTab({ src: icon, alt: id }),
          form: <Form {...props} />,
        };
      });

      return _.filter(forms, form => !_.isEmpty(form));
    } catch (error) {
      return [];
    }
  };

  const handleSubmitSSO = async ({ phone, pin }) => {
    let resSSO;
    try {
      const { SAMLRequest, countryCode } = window.hboKeys;
      const paramsHBO = { country_code: countryCode };
      resSSO = await postAuthHBOSSO(
          {
            numberfield: phone,
            otp: pin,
            SAMLRequest,
          },
          paramsHBO,
      );

      checkApiCallInvariant(
          resSSO,
          '(LoginSSO) Fails request to sends pin user',
      );
      const { response } = resSSO;
      const { destinationUrl, SAMLResponse, method } = response;
      const { idp, RelayState: relayState } = window.hboKeys;
      if (method === 'HTTP-Redirect') {
        let redirection = `${destinationUrl}&SAMLResponse=${SAMLResponse}`;
        if (idp) redirection = `${redirection}&idp=${idp}`;
        else if (relayState)
          redirection = `${redirection}&relayState=${relayState}`;
        window.location = redirection;
      } else {
        handleHboLoginResponse(
            destinationUrl,
            SAMLResponse,
            idp || null,
            relayState || null,
        );
      }
    } catch (error) {
      const defaultError = _.get(
          resSSO,
          ['errors', '0', 'code'],
          constants.DEFAULT_ERROR_CODE,
      );
      const CODE_ERROR = _.get(resSSO, ['errors', 'code'], defaultError);
      handleApiError(CODE_ERROR);
    }
  };

  const handleSubmitPhoneNumber = async ({ phone }) => {
    let resSSO;
    try {
      const { SAMLRequest, country_code } = window.hboKeys;
      const paramsHBO = { country_code };
      resSSO = await postAuthHBOSSO(
          { numberfield: phone, SAMLRequest },
          paramsHBO,
      );

      checkApiCallInvariant(
          resSSO,
          '(LoginSSO) Fails request to sends pin user',
      );
      /*setState({
        pinCodeSent: true,
        pinModal: {
          show: true,
        },
      });*/
    } catch (error) {
      const CODE_ERROR = _.get(
          resSSO,
          ['errors', 'code'],
          _.get(resSSO, ['errors', '0', 'code'], 'UNHANDLED_ERROR'),
      );
      handleApiError(CODE_ERROR);
    }
  };

  const handleLoginByEmail = async ({ email, password }, { hogar }) => {
    let resUserLogin;
    //setState({ loading: true });
    try {
      const { SAMLRequest, country_code } = window.hboKeys;
      const paramsHBO = { country_code };
      const body = {
        username: email,
        password,
        SAMLRequest,
      };

      if (country_code === 'CO' && hogar) {
        paramsHBO.platform = 'clp';
      }

      resUserLogin = await postLoginHbo(body, paramsHBO);
      checkApiCallInvariant(
          resUserLogin,
          '(user/Login) Fails in request login',
          resUserLogin,
      );
      const { response } = resUserLogin;
      const { destinationUrl, SAMLResponse, method } = response;
      const { idp, RelayState: relayState } = window.hboKeys;
      if (method === 'HTTP-Redirect') {
        return console.log('redirect');

        let redirection = `${destinationUrl}&SAMLResponse=${SAMLResponse}`;
        if (idp) redirection = `${redirection}&idp=${idp}`;
        else if (relayState)
          redirection = `${redirection}&relayState=${relayState}`;
        window.location = redirection;
      } else {
        handleHboLoginResponse(
            destinationUrl,
            SAMLResponse,
            idp || null,
            relayState || null,
        );
      }
    } catch (err) {
      //setState({ loading: false });
      const defaultError = _.get(
          resUserLogin,
          ['errors', '0', 'code'],
          constants.DEFAULT_ERROR_CODE,
      );
      const CODE_ERROR = _.get(resUserLogin, ['errors', 'code'], defaultError);
      handleApiError(CODE_ERROR);
    }
  };

  const handleApiError = codeError => {
    const errorsPlaceholder = _.get(getMetadataModel(state), [
      constants.SSO_PLACEHOLDER_ERRORS,
      state.region,
    ]);

    const formError = getFormErrors(
        codeError,
        getTranslationsState(state),
        errorsPlaceholder,
    );

    if (!_.isEmpty(formError)) {
      /*setState(() => ({
        formsController: {
          email: { value: '' },
          password: { value: '' },
          msisdn: { value: '' },
          otp: { value: '' },
          ...formError,
        },
      }));*/
    } else {
      /*setState({
        failModal: {
          show: true,
          msg: converter.convertApa(
              // eslint-disable-next-line react/no-access-state-in-setstate
              getTranslationsState(state),
              codeError,
          ),
        },
      });*/
    }
  };

  const handleHboLoginResponse = (url, samlResponse, idp, relayState) => {
    const urlHboRedirect = `${url}`;

    const formPostInvisible = document.createElement('form');
    formPostInvisible.setAttribute('method', 'POST');
    formPostInvisible.setAttribute('action', urlHboRedirect);

    if (idp) {
      const idpField = document.createElement('input');
      idpField.setAttribute('type', 'hidden');
      idpField.setAttribute('name', 'idp');
      idpField.setAttribute('value', idp);
      formPostInvisible.appendChild(idpField);
    }

    if (relayState) {
      const relayStateField = document.createElement('input');
      relayStateField.setAttribute('type', 'hidden');
      relayStateField.setAttribute('name', 'relayState');
      relayStateField.setAttribute('value', relayState);
      formPostInvisible.appendChild(relayStateField);
    }

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', 'SAMLResponse');
    hiddenField.setAttribute('value', samlResponse);
    formPostInvisible.appendChild(hiddenField);

    document.body.appendChild(formPostInvisible);
    formPostInvisible.submit();
  }

  const handleTabChange = () => {
    const { resetStep } = state;
    /*setState({
      loading: false,
      resetStep: !resetStep,
      pinCodeSent: false,
      pinModal: {
        show: false,
      },
      formsController: {
        email: { value: '' },
        password: { value: '' },
        msisdn: { value: '' },
        otp: { value: '' },
      },
      failModal: {
        msg: '',
        show: false,
      },
    });*/
  };

  const handleFormChange = event => {
    const value = _.get(event, ['target', 'value']);
    const name = _.get(event, ['target', 'name']);
    /*setState(state => ({
      formsController: {
        ...state.formsController,
        [name]: {
          ...state.formsController[name],
          value,
        },
      },
    }));*/
  };

  const handleClearErrors = () => {
    //if (state.failModal.show)
      /*setState({
        loading: false,
        failModal: {
          msg: '',
          show: false,
        },
      });*/
  };

  const renderRegionNotSupported = () => (
      <div>
        <h1 className="hbo-message">{constants.NOT_SUPPORT_REGION}</h1>
      </div>
  );

  const renderErrorOnRequests = () => (
      <div>
        <h1 className="hbo-message">{constants.ERROR_TRY_AGAIN}</h1>
      </div>
  );

  const renderFailModal = () => {
    const classes = {
      'text-center': true,
      'full-width': true,
      fa: true,
      'fa-3x': true,
      'fa-times': true,
    };
    const classesForIcon = classNames(classes);
    const closeModal = () => {
     // setState({ failModal: { show: false, msg: '' } });
    };
    return (
        <Modal show={state.failModal.show}>
          <Modal.Header>
            <Button className="close close-modal" onClick={closeModal}>
              x
            </Button>
            <h4 className="text-center">{constants.UNEXPECTED_ERROR}</h4>
          </Modal.Header>
          <Modal.Body className="modal-body text-center success">
            <i className={classesForIcon} />
            <p
                className="padding-top-2"
                dangerouslySetInnerHTML={{ __html: state.failModal.msg }}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="footer-modal-button flex-end">
              <Button onClick={closeModal}>{constants.CLOSE}</Button>
            </div>
          </Modal.Footer>
        </Modal>
    );
  };

  const renderPinModal = () => {
    const classes = {
      'text-center': true,
      'full-width': true,
      fa: true,
      'fa-3x': true,
      'fa-check-circle': true,
    };
    const classesForIcon = classNames(classes);
    setTimeout(() => {
      //setState({ pinModal: { show: false } });
    }, 3000);
    return (
        <Modal show={state.pinModal.show} className="tiny-modal">
          <Modal.Body className="modal-body text-center success">
            <i className={classesForIcon} />
            <p className="padding-top-2">
              !Codigo de validacion enviado correctamente a tu celular!
            </p>
          </Modal.Body>
        </Modal>
    );
  };


  const [state, dispatch] = useReducer(Reducer, initialState);
  useEffect(() => {
    const init = async () => {
      dispatch({ type: LOADING_DATA });
      try {
        const { params: hksParams, HKS } = REQUEST_DATA;
        const startHIParams = {
          ...hksParams,
          HKS,
        };
        const resStartHeaderInfo = await getStartHeaderInfo(startHIParams);
        checkApiCallInvariant(
            resStartHeaderInfo,
            '(StartHeaderInfo) Fails to call hks',
        );
        const { response: resHks } = resStartHeaderInfo;
        const REGION = resHks.region;
        const responseConfig = getConfigEnv(REGION);
        const defaults = _.pick(responseConfig, [
          'authpn',
          'authpt',
          'api_version',
          'user_hash',
        ]);
        const rest = {
          device_id: 'web',
          device_category: 'web',
          device_model: 'web',
          device_type: 'web',
          format: 'json',
          device_so: getBrowser(),
          device_manufacturer: 'generic',
          HKS: resHks.session_stringvalue,
        };
        const params = _.merge({}, rest, defaults);
        updateDefaultsHBO(api, {
          params,
        });

        const resMetadata = await getApaMetadata({
          sessionKey: `${responseConfig.app_key}-${REGION}`,
        });

        const resAssets = await getApaAssets({
          sessionKey: `${responseConfig.app_key}-${REGION}`,
        });
        const payload = {
          region: REGION,
          metadata: resMetadata,
          assets: resAssets,
          responseConfig
        };
        dispatch({ type: SET_DATA, payload });
      } catch (e) {
        dispatch({ type: ERROR });
      }
    }
    init();
  }, []);

  return {
    state,
    getForms,
    handleSubmitSSO,
    handleSubmitPhoneNumber,
    handleLoginByEmail,
    handleApiError,
    handleHboLoginResponse,
    handleTabChange,
    handleFormChange,
    handleClearErrors,
    renderRegionNotSupported,
    renderErrorOnRequests,
    renderFailModal,
    renderPinModal
  };
};

export default useHboLogin;
